import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { fetchStudentAuthVUnauthAttendance } from "./api"

export const studentAuthVsUnauthQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentAuthVsUnauth', studentNo],
        queryFn: () => fetchStudentAuthVUnauthAttendance(studentNo),
    })

export function useStudentAuthVsUnauth(studentNo: string) {
    return useQuery(studentAuthVsUnauthQueryOptions(studentNo))
}

export function useStudentAuthVsUnauthSuspense(studentNo: string) {
    return useSuspenseQuery(studentAuthVsUnauthQueryOptions(studentNo))
}
